class ByteUtils {
  static UINT32_MAX = 4294967295;

  static stringToArrayBuffer(string) {
    const buffer = new ArrayBuffer(string.length);
    const dataView = new DataView(buffer);
    for (let i = 0; i < string.length; i++) {
      dataView.setUint8(i, string.charCodeAt(i));
    }
    return buffer;
  }

  static arrayBufferToString(buffer) {
    if (buffer === null) return null;
    const dataView = new DataView(buffer);
    let string = '';
    for (let i = 0; i < buffer.byteLength; i++) {
      string = string.concat(String.fromCharCode(dataView.getUint8(i)));
    }

    return string;
  }

  static byteArrayToArrayBuffer(bytes) {
    return new Uint8Array(bytes).buffer;
  }

  // Sourced from https://stackoverflow.com/a/34310051.
  static arrayBufferToHexString(buffer) {
    const dataView = new DataView(buffer);
    let s = '0x';
    for (let i = 0; i < buffer.byteLength; i++) {
      s += ('0' + (dataView.getUint8(i) & 0xff).toString(16)).slice(-2);
    }
    return s;
  }
}

export default ByteUtils;
